import React from 'react'

import clsx from 'clsx'

import Icon from '@/components/Icon'

export type InfoMessageType = 'success' | 'rejected' | 'pending' | 'error'

export const getStatusProps = (type: InfoMessageType) => {
  switch (type) {
    case 'success':
      return {
        background: 'bg-emerald-200',
        iconBackground: 'bg-emerald-200',
        iconColor: 'text-white',
        iconName: 'check-24'
      }
    case 'rejected':
      return {
        background: 'bg-slate-100',
        iconBackground: 'bg-slate-200',
        iconColor: 'text-secondary-500',
        iconName: 'close-24'
      }
    case 'error':
      return {
        background: 'bg-rose-100',
        iconBackground: 'bg-rose-500',
        iconColor: 'text-white',
        iconName: 'close-24'
      }

    case 'pending':
      return {
        background: 'bg-amber-100',
        iconBackground: 'bg-amber-200',
        iconColor: 'text-amber-500',
        iconName: 'clock-24'
      }
    default:
      return {
        background: 'bg-amber-100',
        iconBackground: 'bg-amber-200',
        iconColor: 'text-amber-500',
        iconName: 'clock-24'
      }
  }
}

interface InfoMessageProps {
  title: string
  type: InfoMessageType
  subTitle?: string
  buttonComponent?: JSX.Element
  className?: string
}

const InfoMessage = ({
  title,
  subTitle,
  type,
  className,
  buttonComponent
}: InfoMessageProps) => {
  const { background, iconColor, iconName, iconBackground } =
    getStatusProps(type)

  return (
    <div
      className={clsx(
        'relative flex flex-col gap-3 rounded-xl p-3 desktop:flex-row desktop:items-center desktop:justify-between desktop:gap-6 desktop:py-4',
        className,
        background
      )}
    >
      <div className="flex items-center gap-3">
        <span
          className={clsx(
            'flex h-10 w-10 flex-none items-center justify-center rounded-full desktop:h-13 desktop:w-13',
            iconBackground
          )}
        >
          <Icon
            className={clsx('h-6 w-6 flex-none', iconColor)}
            name={iconName}
          />
        </span>
        <div className="flex max-w-[600px] flex-auto flex-col gap-0.5">
          <h5 className="text-x-base font-medium leading-x-base">{title}</h5>
          {subTitle && <p className="text-x-base leading-x-base">{subTitle}</p>}
        </div>
      </div>
      {buttonComponent && (
        <div className="flex items-center gap-2.5">{buttonComponent}</div>
      )}
    </div>
  )
}

export default InfoMessage
